import React, { lazy } from "react";
import { RouteObject } from "react-router-dom";

const DashboardHome = lazy(() => import("./DashboardHome"));

const HOMEDASH_ROUTES: RouteObject[] = [
  {
    path: "/private/home",
    element: React.createElement(DashboardHome),
  },
];

export default HOMEDASH_ROUTES;
